import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SlotGameModel from 'Engine/slots/model/SlotGameModel';
import eBigWinDefaultCoefs from './eBigWinDefaultCoefs';
import eBigWinTypes from './eBigWinTypes';
import ServerManager from '../server/ServerManager';

export default new class GameModel extends SlotGameModel {
  constructor() {
    super();
    this._respins = 0;
    this._bonusGameTotalWin = 0;
    this._lastWin = 0;
    this._bonusGameTriggered = false;

    GlobalDispatcher.addOnce('model:getServerData', () => {
      this._winRankCoef = {
        [eBigWinTypes.EBWT_BIG_WIN]: OPWrapperService.config.minWinRankCoef ? OPWrapperService.config.minWinRankCoef : eBigWinDefaultCoefs.EBWC_BIG_WIN,
        [eBigWinTypes.EBWT_MEGA_WIN]: eBigWinDefaultCoefs.EBWC_MEGA_WIN
      };
    }, this);
  }

  init() {
    super.init();
    ServerManager.onInit();
  }

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add('ui:setMinBet', this.onMinBetPressed, this);
  }

  setNewData(data) {
    this._lastWin = this.totalWin || this._lastWin;
    this._jackpotData = data.jackpot;

    super.setNewData(data);
    if (data.freespinsData) {
      this._freespinsTotalWin = data.freespinsData.totalWin || 0;
      this._freespins = data.freespinsData.freespins;
      this._freespinsTriggered = data.freespinsData.freespinsTriggered;
      this._freeSpinsAvailableReels = data.availableReels || this._freeSpinsAvailableReels;
    }

    this._isFreeSpinsMode = data.freespinsData && data.freespinsData.isFreespinsGame;

    this._isBonusGameMode = data.bonusGameData && data.bonusGameData.isBonusGame;
    this._jackpotCoeffs = data.jackpotCoeffs || this._jackpotCoeffs;

    GlobalDispatcher.dispatch('model:getServerData', data.action);
  }

  changeBet(index) {
    if (index >= this._betPossible.length) index = this._betPossible.length - 1;
    if (index < 0) index = 0;

    this.betIndex = index;
  }

  onMinBetPressed() {
    this.changeBet(0);
  }

  get paytableInfo() {
    return this._paytableInfo;
  }

  get isJackpot() {
    return this._jackpotData.is_jackpot;
  }

  get freespins() {
    return this._freespins;
  }
  set freespins(value) {
    this._freespins = value;
  }
  get freespinsTotalWin() {
    return this._freespinsTotalWin;
  }
  set freespinsTotalWin(value) {
    this._freespinsTotalWin = value;
  }
  get isFreeSpinsMode() {
    return this._isFreeSpinsMode;
  }
  get freespinsEnabled() {
    return this._bonusGameEnabled;
  }
  set freespinsEnabled(value) {
    this._bonusGameEnabled = value;
    this._isSpinWithoutBalanceCheck = value;
  }
  get freespinsTriggered() {
    return this._freespinsTriggered;
  }

  get jackpotList() {
    return this._jackpotCoeffs.map(coef => this.bet * coef);
  }

  get jackpotMaxWin() {
    const maxBet = this._betPossible[this._betPossible.length - 1];
    return this._jackpotCoeffs[this._jackpotCoeffs.length - 1] * maxBet;
  }

  get respins() {
    return this._respins;
  }

  set respins(value) {
    this._respins = value;
  }

  get bonusGameTotalWin() {
    return this._bonusGameTotalWin;
  }

  set bonusGameTotalWin(value) {
    this._bonusGameTotalWin = value;
  }

  get isBonusGameMode() {
    return this._isBonusGameMode;
  }

  get totalWin() {
    let win = this._jackpotData?.win_amount || 0;
    if (this._winnings) {
      win += this.winnings.totalWin;
    }
    return win;
  }

  get lastWin() {
    return this._lastWin;
  }

  get freespinsAvalibleReels() {
    return this._freeSpinsAvailableReels;
  }

  get winRankCoef() {
    return this._winRankCoef;
  }
}
